import { Component, OnDestroy, inject } from "@angular/core";
import { AnnotationUtilsService } from "@core/services/utils/annotation-utils.service";
import { LegalRecordStateService } from "@core/services/utils/legal-record-state.service";
import { LegalRecordUI } from "@services/business/_models/interfaces/record.interfaces";
import { LCObjectTypeEnum } from "@services/ui-helpers/_models/interfaces/common.interfaces";
import { ParticipantTypeEnum } from "@services/ui-helpers/_models/interfaces/messaging.interfaces";
import { ContactCardComponent } from "@ui/components/contact-card/contact-card.component";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "contact-sidebar",
  templateUrl: "./contact-sidebar.component.html",
  styleUrl: "./contact-sidebar.component.scss",
  imports: [ContactCardComponent],
})
export class ContactSidebarComponent implements OnDestroy {
  private readonly legalRecordStateService = inject(LegalRecordStateService);
  private readonly annotationUtilsService = inject(AnnotationUtilsService);

  protected ParticipantTypeEnum = ParticipantTypeEnum;
  protected currentRecordInfo: LegalRecordUI | undefined;
  public hasAnnotations = false;

  private readonly destroy$ = new Subject<void>();

  constructor() {
    this.initializeData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeData(): void {
    this.legalRecordStateService
      .getCurrentRecordInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe(record => {
        this.currentRecordInfo = record;
        this.hasAnnotations = (record?.annotationsCount ?? 0) > 0;
      });
  }

  onAnnotationsClick(): void {
    if (!this.currentRecordInfo?.recordId) {
      console.warn("No record recordId available for annotations");
      return;
    }

    // Use the annotation utils service to show record-level annotations
    this.annotationUtilsService.showRecordAnnotations(
      this.currentRecordInfo.recordId,
      LCObjectTypeEnum.legalrecord
    );
  }
}
